(() => {
  if (window.__taymiScrollLockRecovery) return;
  window.__taymiScrollLockRecovery = true;

  const lockClasses = ['has-modal-opening', 'has-modal-open'];
  const lockingLayers = [
    'menu-drawer[open]',
    'cart-drawer[open]',
    'search-drawer[open]',
    'drawer-element[open]',
    'modal-element[open]',
    'newsletter-modal[open]',
    '.drawer[open]',
    '.x-modal[open]'
  ].join(',');
  let releaseTimer;

  const isVisibleLockingLayer = (layer) => {
    if (!layer.hasAttribute('open') || !layer.hasAttribute('active') || layer.hidden) return false;
    const layerStyle = getComputedStyle(layer);
    if (layerStyle.display === 'none' || layerStyle.visibility === 'hidden' || Number(layerStyle.opacity) <= 0.01) return false;

    const panel = layer.querySelector('.drawer__inner, .modal__container') || layer;
    const panelStyle = getComputedStyle(panel);
    const rect = panel.getBoundingClientRect();
    return panelStyle.display !== 'none'
      && panelStyle.visibility !== 'hidden'
      && Number(panelStyle.opacity) > 0.01
      && rect.width > 0
      && rect.height > 0
      && rect.right > 0
      && rect.bottom > 0
      && rect.left < window.innerWidth
      && rect.top < window.innerHeight;
  };

  const releaseOrphanedLock = () => {
    const body = document.body;
    if (!body || !lockClasses.some((className) => body.classList.contains(className))) return;
    if (Array.from(document.querySelectorAll(lockingLayers)).some(isVisibleLockingLayer)) return;

    body.classList.remove(...lockClasses);
    body.style.removeProperty('overflow');
    body.style.removeProperty('overflow-y');
    body.style.removeProperty('padding-inline-end');
    body.style.removeProperty('padding-right');
    body.style.removeProperty('touch-action');
    document.documentElement.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow-y');
  };

  const scheduleCheck = (delay = 1100) => {
    clearTimeout(releaseTimer);
    releaseTimer = setTimeout(releaseOrphanedLock, delay);
  };

  const start = () => {
    const documentObserver = new MutationObserver(() => scheduleCheck());
    documentObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open', 'active'],
      childList: true,
      subtree: true
    });

    const bodyObserver = new MutationObserver(() => scheduleCheck());
    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    document.addEventListener('modal:afterHide', () => scheduleCheck(0), true);
    document.addEventListener('drawer:afterHide', () => scheduleCheck(0), true);
    window.addEventListener('pageshow', () => scheduleCheck(0));
    document.addEventListener('visibilitychange', () => scheduleCheck(0));
    scheduleCheck(0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
